module.exports = __webpack_public_path__ + "img/13_1.b4d64cca.png";